/**
 * Globale Stores: Toasts, Bestätigungsdialog, Theme, Seitenleiste.
 */
export function registerStores(Alpine) {
    Alpine.store('toasts', {
        items: [],
        seq: 0,

        boot(initial) {
            (initial || []).forEach((toast) => this.push(toast));
        },

        push({ message, type = 'success', undo = null, duration = null }) {
            if (!message) return;
            type = { danger: 'error', warning: 'warning', info: 'info', error: 'error' }[type] || 'success';

            const toast = {
                id: ++this.seq,
                message,
                type,
                undo,
                visible: true,
                remaining: duration ?? (undo || type === 'error' ? 8000 : 4000),
                started: 0,
                timer: null,
            };

            this.items.push(toast);
            if (this.items.filter((t) => t.visible).length > 4) this.dismiss(this.items.find((t) => t.visible));
            this.resume(toast);
        },

        pause(toast) {
            clearTimeout(toast.timer);
            toast.remaining -= Date.now() - toast.started;
        },

        resume(toast) {
            toast.started = Date.now();
            toast.timer = setTimeout(() => this.dismiss(toast), Math.max(toast.remaining, 1500));
        },

        dismiss(toast) {
            clearTimeout(toast.timer);
            toast.visible = false;
            setTimeout(() => (this.items = this.items.filter((t) => t.id !== toast.id)), 250);
        },

        undo(toast) {
            const { component, method, params } = toast.undo;
            this.dismiss(toast);
            const wire = window.Livewire?.find(component);
            if (wire) {
                wire.$call(method, ...(params || []));
            } else {
                this.push({ message: 'Rückgängig ist hier nicht mehr möglich.', type: 'error' });
            }
        },

        icon(type) {
            return {
                success: 'bi-check-circle-fill',
                error: 'bi-exclamation-octagon-fill',
                warning: 'bi-exclamation-triangle-fill',
                info: 'bi-info-circle-fill',
            }[type];
        },
    });

    const confirmDefaults = {
        title: 'Bist du sicher?',
        text: '',
        confirmLabel: 'Bestätigen',
        cancelLabel: 'Abbrechen',
        tone: 'primary',
        icon: null,
    };

    Alpine.store('confirm', {
        open: false,
        ...confirmDefaults,
        resolver: null,

        ask(options = {}) {
            this.resolver?.(false);
            Object.assign(this, confirmDefaults, options);
            this.icon = options.icon || (this.tone === 'danger' ? 'bi-exclamation-triangle' : 'bi-question-circle');
            this.open = true;

            return new Promise((resolve) => (this.resolver = resolve));
        },

        answer(value) {
            this.open = false;
            this.resolver?.(value);
            this.resolver = null;
        },
    });

    Alpine.store('theme', {
        value: window.nnTheme.get(),

        cycle() {
            this.value = { auto: 'light', light: 'dark', dark: 'auto' }[this.value];
            window.nnTheme.set(this.value);
        },

        get icon() {
            return { auto: 'bi-circle-half', light: 'bi-sun', dark: 'bi-moon-stars' }[this.value];
        },

        get label() {
            return { auto: 'Design: wie System', light: 'Design: hell', dark: 'Design: dunkel' }[this.value];
        },
    });

    // Seitenleiste (ab lg) eingeklappt: gespeichert pro Gerät, Attribut am <html> (siehe head)
    Alpine.store('sidebar', {
        collapsed: document.documentElement.getAttribute('data-nn-sidebar') === 'collapsed',

        toggle() {
            this.collapsed = !this.collapsed;
            if (this.collapsed) {
                document.documentElement.setAttribute('data-nn-sidebar', 'collapsed');
            } else {
                document.documentElement.removeAttribute('data-nn-sidebar');
            }
            try {
                localStorage.setItem('nn-sidebar', this.collapsed ? 'collapsed' : 'expanded');
            } catch (e) {
                // privater Modus o. Ä. – dann gilt die Wahl nur bis zum Neuladen
            }
        },
    });

    window.nnConfirm = (options) => Alpine.store('confirm').ask(options);
    window.nnToast = (toast) => Alpine.store('toasts').push(toast);
    Alpine.magic('confirm', () => window.nnConfirm);

    // Livewire: $this->dispatch('toast', message: …) kommt als Browser-Event an
    window.addEventListener('toast', (event) => window.nnToast(event.detail));
}
